export default __webpack_public_path__ + "static/media/ contactIcon.f040cb97.svg";